var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.2 14.3-9.6-9.8c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l8.2 8.4-8.2 8.2c-.8.8-.8 2 0 2.8s2 .8 2.8 0l9.6-9.6c.8-.9.8-2.1 0-2.8"
  })));
};
export default SvgCaretRight;